import { batch } from 'react-redux';
import type { Dispatch } from 'redux';

import { routeToPageIdMapping } from 'src/app/routes/routeToPageIdMapping';

import { actionUpdatePageId } from '../../modules/session/pageId';
import { actionUpdatePage } from '../../modules/tealium/page';
import { tealiumPagePageIdMapping } from '../tealium';

export const dispatchPageId = (dispatch: Dispatch, route: string) => {
  const pageId = routeToPageIdMapping[route];

  if (pageId) {
    batch(() => {
      dispatch(actionUpdatePage(tealiumPagePageIdMapping[pageId] || pageId));
      dispatch(actionUpdatePageId(pageId));
    });
  }
};
